module.exports = __webpack_public_path__ + "static/media/fansfirst-logo-smaller.8d28019a.svg";